(function(){
"use strict";
// KIRA V11: presentation only. Never writes Globo inputs, variant prices, cart or promo rules.
if(new URLSearchParams(location.search).get("kira_editorial")==="0")return;
const $=(sel,root=document)=>root.querySelector(sel);
const $$=(sel,root=document)=>Array.from(root.querySelectorAll(sel));
const titleNorm=s=>String(s||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/\s+/g," ").trim().toUpperCase();
const knownHeadings=[
"LO QUE DICEN NUESTROS CLIENTES",
"TAMBIEN TE PUEDE GUSTAR",
"ASÍ SE VEN NUESTRAS FUNDAS EN LA VIDA REAL",
"ASI SE VEN NUESTRAS FUNDAS EN LA VIDA REAL",
"MIRALO ANTES DE COMPRARLO",
"TU DISENO, PROTEGIDO BAJO RESINA",
"ASI QUEDO LA DE ELLOS",
"MAS POR TU COMPRA"
].map(titleNorm);
function unifyHeadings(){
 const main=$("#MainContent");if(!main)return;
 for(const node of $$("h2,h3",main)){
  if(node.closest(".kira-editorial-intro,.kira-tipo-funda,.kira-acabados,.kira-v11-promo"))continue;
  const label=titleNorm(node.textContent);
  if(label.length<85 && knownHeadings.some(x=>label===x)){
   node.classList.add("kira-v11-unified-heading");
  }
 }
}
function formatCurrency(value){return "$"+Math.round(value).toLocaleString("es-MX")+" MXN";}
function addDisclosure(){
 const info=$(".product-information .product-details");
 const line=$(".kira-case-price-line",info||document);
 const tpl=$(".product-information .kira-v11-promo-template");
 if(!info||!line||!line.parentElement||!tpl)return;
 // Only one disclosure. Move the existing DOM element to preserve its open state.
 const existing=$(".kira-v11-promo",info);
 if(existing){
  if(existing.previousElementSibling!==line)line.insertAdjacentElement("afterend",existing);
  return;
 }
 // Shop price is read-only base price. Globo option prices are not changed here.
 const cents=Number(tpl.dataset.baseCents);
 if(!Number.isSafeInteger(cents)||cents<10000||cents>200000)return;
 const base=cents/100;
 const frag=tpl.content.cloneNode(true);
 const pane=frag.querySelector(".kira-v11-promo");
 if(!pane)return;
 const baseEl=pane.querySelector("[data-kira-v11-base]");
 if(baseEl)baseEl.textContent=formatCurrency(base);
 for(const item of pane.querySelectorAll("[data-kira-v11-add]")){
  item.textContent=formatCurrency(base+Number(item.dataset.kiraV11Add));
 }
 line.insertAdjacentElement("afterend",pane);
}
function retitlePromo(){
 const tag=$(".product-information .product-details .kira-case-price-offer");
 if(!tag)return;
 const text=titleNorm(tag.textContent);
 if(text.includes("2X1")&&(text.includes("ACRIGEL")||text.includes("PRECIO BASE"))){
  tag.setAttribute("title","Lleva 2 fundas Acrigel y paga 1. Si eliges otro tipo, solo pagas el extra de cada funda.");
  if(tag.textContent.trim()!=="2x1 en fundas Acrigel")tag.textContent="2x1 en fundas Acrigel";
 }
}
function apply(){if(!document.body.classList.contains("kira-editorial-on"))return;
 addDisclosure();retitlePromo();unifyHeadings();
}
let timer=0;
function queue(){clearTimeout(timer);timer=setTimeout(apply,100);}
function start(){
 queue();document.addEventListener("gpoRenderCompleted",queue);
 document.addEventListener("change",queue,true);
 const main=$("#MainContent")||document.body;
 const observer=new MutationObserver(queue);observer.observe(main,{childList:true,subtree:true});
 setTimeout(()=>observer.disconnect(),22000);
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});
else start();
})();